export const cookie_slug = "supplier"